module.exports = __webpack_public_path__ + "static/media/chat_darkbleu.3639b2fc.svg";